<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div class="crumbs-box-p">
        <span>匠心记</span>
        <span>&gt;</span>
        <span>创建每周周报</span>
      </div>
      <!-- 主体 -->
      <div class="carate-report-main-p">
        <h2 class="create-report-tit-p">创建每周周报</h2>

        <div class="info-options-p">
          <div class="item-row-p">
            <div class="item-row-left-p">
              <p>周报名</p>
            </div>
            <div class="item-row-right-p">
              <p class="report-title">{{getMonthWeek}}</p>
            </div>
          </div>
          <div class="item-row-p">
            <div class="item-row-left-p">
              <p>本周项目进度总结</p>
            </div>
            <div class="item-row-right-p">
              <textarea placeholder="描述本周项目进度总结....." v-model="form.Pschedule"></textarea>
            </div>
          </div>
          <div class="item-row-p">
            <div class="item-row-left-p">
              <p>添加图片</p>
            </div>
            <div class="item-row-right-p">
              <image-upload :src="src" @getDataArr="getDataArr1">
                <i slot="del" class="del-p"></i>
                <p slot="limitImg" class="limit-img-p">( *不能少于三张)</p>
              </image-upload>
            </div>
          </div>
        </div>

        <div class="info-options-p">
          <div class="item-row-p">
            <div class="item-row-left-p">
              <p>本周安全情况总结</p>
            </div>
            <div class="item-row-right-p">
              <textarea placeholder="描述本周安全情况总结....." v-model="form.Security"></textarea>
            </div>
          </div>
          <div class="item-row-p">
            <div class="item-row-left-p">
              <p>添加图片</p>
            </div>
            <div class="item-row-right-p">
              <image-upload :src="src" @getDataArr="getDataArr2">
                <i slot="del" class="del-p"></i>
                <p slot="limitImg" class="limit-img-p">( *不能少于三张)</p>
              </image-upload>
            </div>
          </div>
        </div>

        <div class="info-options-p last-options">
          <div class="item-row-p">
            <div class="item-row-left-p">
              <p class="line-height-p">本周工作总结以及 下周工作计划</p>
            </div>
            <div class="item-row-right-p">
              <textarea placeholder="描述本周工作总结以及计划......" v-model="form.ThisdayConclusion"></textarea>
            </div>
          </div>
        </div>

        <div class="report-btn-p" @click="upload">
          <p>上传</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../../html/pages/originality/createReport/createReport.scss"

import imageUpload from "../../../../components/imageUpload/ImageUpload"

import { jxjAddReport } from "../../../../api/index"

export default {
  name: 'createReport',
  data() {
    return {
      src: require('../../../../html/pages/originality/createDaily/images/upload.jpg'),
      form:{
        id:this.$route.params.id,
        title:this.getMonthWeek,
        data:null,
        Pschedule:'',
        PscheduleImage:[],
        Security:'',
        SecurityImage:[],
        ThisdayConclusion:'',
      },
      rules: {
        Pschedule: [
          { required: true, message: '请填写项目进度!' },
        ],
        Security: [
          { required: true, message: '请填写安全情况!' },
        ],
        ThisdayConclusion: [
          { required: true, message: '请填写工作总结!' },
        ]
      }
    }
  },
  components: {
    imageUpload
  },
  computed: {
    getMonthWeek() {
      let now = new Date()
      let y = now.getFullYear()
      let m = now.getMonth() + 1
      let d = now.getDate()
      let w = now.getDay()
      let MonthWeek
      if (w == 0) w = 7
      if (d < w) {
        MonthWeek = 1
      } else {
        MonthWeek = Math.ceil((d - w) / 7) + 1
      }
      switch (MonthWeek) {
        case 1:
          MonthWeek = "一"
          break
        case 2:
          MonthWeek = "二"
          break
        case 3:
          MonthWeek = "三"
          break
        case 4:
          MonthWeek = "四"
          break
        case 5:
          MonthWeek = "五"
          break
        case 6:
          MonthWeek = "六"
          break
      }
      return `${y}年${m}月第${MonthWeek}周周报`
    }
  },
  methods: {
    getDataArr1(data) {
      this.form.PscheduleImage = data
    },
    getDataArr2(data){
      this.form.SecurityImage = data
    },
    async upload(){
      let validator = new this.$validator(this.rules);
      let model = this.form;
      validator.validate(model, async (errors, fields) => {
        if (!errors) {
          if(this.form.PscheduleImage.length < 3){
            return this.$layer.alert("项目进度图片不能少于三张!")
          }
          if(this.form.SecurityImage.length < 3){
            return this.$layer.alert("安全情况图片不能少于三张!")
          }
          this.form.PscheduleImage = this.form.PscheduleImage.join(",")
          this.form.SecurityImage = this.form.SecurityImage.join(",")
          let res = await jxjAddReport(this.form);
          if (res.Type == 'Success') {
            this.$layer.msg(res.Content, (msg) => {
              this.$layer.close(msg)
              this.$router.push({ name: "jxjDetail", params: { id: this.$route.params.id } })
            })
          }else{
            this.$layer.alert(res.Content)
          }
        } else {
          this.$layer.alert(errors[0].message);
        }
      });
    }
  },
  created(){
    this.form.title = this.getMonthWeek
  }
}
</script>